import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import './dailyVehiclesWholesale.scss';

const valueIfNull = '0';

class DataTable extends Component {
  fixNumber = (numToFix) => {
    return Number(numToFix) !== 0 ? Number(numToFix).toFixed(0) : 0;
  }

  getValue = (type, saleType) => {
    const {wholeSalesAndStockList} = this.props;
    if (wholeSalesAndStockList.length > 0) {
      return wholeSalesAndStockList.map((item) => {
        switch (type) {
          case 'forecast':
            return item.vehicleForecast.length > 0 ? item.vehicleForecast.find((f) => f.salesType === saleType) ?
              item.vehicleForecast.find((f) => f.salesType === saleType).totalQty : 0 : 0;
  
          case 'sales':
            return item.vehicleSales.length > 0 ? item.vehicleSales.find((f) => f.salesType === saleType) ?
              item.vehicleSales.find((f) => f.salesType === saleType).totalQty : 0 : 0;
          
          case 'prioritized':
            return item.vehiclePrioritized ? item.vehiclePrioritized : 0;

          case 'availability':
            return item.vehicleAvailability ? item.vehicleAvailability[saleType] : 0;

          default:
            return 0;
        }
      }).reduce((a, b) => a + (b || 0));
    }
  }

  getTotals = () => {
    const totalForecastNormal = this.getValue('forecast', 'N');
    const totalForecastExonerated = this.getValue('forecast', 'E');
    const totalForeCast = totalForecastNormal + totalForecastExonerated;
    const totalSalesNormal = this.getValue('sales', 'N');
    const totalSalesExonerated = this.getValue('sales', 'E');
    const totalSales = totalSalesNormal + totalSalesExonerated;
    const totalAvailabilityR1 = this.getValue('availability', 'R1');
    const totalAvailabilityR2 = this.getValue('availability', 'R2');
    const totalAvailabilityR3 = this.getValue('availability', 'R3');
    const totalAvailabilityR4 = this.getValue('availability', 'R4');
    const totalAvailabilityR5 = this.getValue('availability', 'R5');
    const totalPrioritized = this.getValue('prioritized');
    const totalProyected = totalPrioritized + totalSales;
    const totalCmp = (totalProyected / totalForeCast) * 100;
    return {
      'totalForeCast': totalForeCast,
      'totalForecastNormal': totalForecastNormal,
      'totalForecastExonerated': totalForecastExonerated,
      'totalSales': totalSales,
      'totalSalesNormal': totalSalesNormal,
      'totalSalesExonerated': totalSalesExonerated,
      'totalPrioritized': totalPrioritized,
      'totalProyected': totalProyected,
      'totalCMP': totalCmp,
      'totalAvailabilityR1': totalAvailabilityR1,
      'totalAvailabilityR2': totalAvailabilityR2,
      'totalAvailabilityR3': totalAvailabilityR3,
      'totalAvailabilityR4': totalAvailabilityR4,
      'totalAvailabilityR5': totalAvailabilityR5,
      'totalAvailability': totalAvailabilityR1 + totalAvailabilityR2 + totalAvailabilityR3 +
        totalAvailabilityR4 + totalAvailabilityR5,
    };
  }

  renderFirstHeaderRow() {
    const styles = 'lightgray-bg t-bold full-border static-column';
    return (
      <Table.Row textAlign='center'>
        <Table.HeaderCell className={styles} rowSpan='3'>Modelos</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='3'>Facturación Whole Planeada</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='3'>Facturación Whole Real</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='2'>Proyección de entregas</Table.HeaderCell>
        <Table.HeaderCell className={styles} rowSpan='3'>% Cmp</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='6'>DISPONIBILIDAD</Table.HeaderCell>
      </Table.Row>
    );
  }

  renderSecondHeaderRow() {
    const styles = 'lightgray-bg t-bold full-border second-row-of-header static-column';
    return (
      <Table.Row textAlign='center'>
        <Table.HeaderCell className={styles}>Plan</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='2'>Normal/Exonerado</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Real</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='2'>Semana</Table.HeaderCell>
        <Table.HeaderCell className={styles} rowSpan='2'>Priorizados al momento</Table.HeaderCell>
        <Table.HeaderCell className={styles} rowSpan='2'>Proyección en Firme</Table.HeaderCell>
        <Table.HeaderCell className={styles} colSpan='6'>
          Días en Disponibilidad de Inventario TDE (Normal)</Table.HeaderCell>
      </Table.Row>
    );
  }

  renderThirdHeaderRow() {
    const styles = 'lightgray-bg t-bold full-border third-row-of-header static-column';
    return (
      <Table.Row textAlign='center'>
        <Table.HeaderCell className={styles}>TDE</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Normal</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Exonerado</Table.HeaderCell>
        <Table.HeaderCell className={styles}>TDE</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Normal</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Exonerado</Table.HeaderCell>
        <Table.HeaderCell className={styles}>1-15 Días</Table.HeaderCell>
        <Table.HeaderCell className={styles}>16-30 Días</Table.HeaderCell>
        <Table.HeaderCell className={styles}>31-60 Días</Table.HeaderCell>
        <Table.HeaderCell className={styles}>61-80 Días</Table.HeaderCell>
        <Table.HeaderCell className={styles}>80 Días</Table.HeaderCell>
        <Table.HeaderCell className={styles}>Stock</Table.HeaderCell>
      </Table.Row>
    );
  }

  renderLoaderOrData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation() {
    const {wholeSalesAndStockList} = this.props;
    if (wholeSalesAndStockList.length > 0) {
      const cells = wholeSalesAndStockList.map((record, index) => {
        const availabilityR1 = record.vehicleAvailability.R1;
        const availabilityR2 = record.vehicleAvailability.R2;
        const availabilityR3 = record.vehicleAvailability.R3;
        const availabilityR4 = record.vehicleAvailability.R4;
        const availabilityR5 = record.vehicleAvailability.R5;
        const availabilityTotal = availabilityR1 + availabilityR2 + availabilityR3 + availabilityR4 + availabilityR5;
        return (
          <Table.Row textAlign='center' key={index}>
            <Table.Cell collapsing className='lightgray-bg static-column'>{record.vehicleModelName}</Table.Cell>
            {this.renderForecastAndSales(record)}
            <Table.Cell>{availabilityR1 || valueIfNull}</Table.Cell>
            <Table.Cell>{availabilityR2 || valueIfNull}</Table.Cell>
            <Table.Cell>{availabilityR3 || valueIfNull}</Table.Cell>
            <Table.Cell>{availabilityR4 || valueIfNull}</Table.Cell>
            <Table.Cell>{availabilityR5 || valueIfNull}</Table.Cell>
            <Table.Cell>{availabilityTotal || valueIfNull}</Table.Cell>
          </Table.Row>
        );
      });
      return cells;
    }
  }

  renderForecastAndSales(record) {
    const vehicleForecastNormal = record.vehicleForecast.find((x) => x.salesType === 'N');
    const vehicleForecastExonerated = record.vehicleForecast.find((x) => x.salesType === 'E');
    const salesForecastNormal = vehicleForecastNormal ? vehicleForecastNormal.totalQty : 0;
    const salesForecastExonerated = vehicleForecastExonerated ? vehicleForecastExonerated.totalQty : 0;
    const salesForacastTotal = salesForecastNormal + salesForecastExonerated;
    const vehiceleSalesNormal = record.vehicleSales.find((x) => x.salesType === 'N');
    const vehiceleSalesExonerated = record.vehicleSales.find((x) => x.salesType === 'E');
    const totalSalesNormal = vehiceleSalesNormal ? vehiceleSalesNormal.totalQty : 0;
    const totalSalesExonerated = vehiceleSalesExonerated ? vehiceleSalesExonerated.totalQty : 0;
    const totalSales = totalSalesNormal + totalSalesExonerated;
    const priorized = record.vehiclePrioritized;
    const proyected = priorized + totalSales;
    const cmpCalc = salesForacastTotal === 0 && proyected > 0 ? proyected * 100 :
      (proyected / salesForacastTotal) * 100;
    const cmp = Number.isFinite(cmpCalc) ? cmpCalc : 0;
    return (
      <React.Fragment>
        <Table.Cell>{salesForacastTotal || valueIfNull}</Table.Cell>
        <Table.Cell>{salesForecastNormal || valueIfNull}</Table.Cell>
        <Table.Cell>{salesForecastExonerated || valueIfNull}</Table.Cell>
        <Table.Cell>{totalSales || valueIfNull}</Table.Cell>
        <Table.Cell>{totalSalesNormal || valueIfNull}</Table.Cell>
        <Table.Cell>{totalSalesExonerated || valueIfNull}</Table.Cell>
        <Table.Cell>{priorized || valueIfNull}</Table.Cell>
        <Table.Cell>{proyected || valueIfNull}</Table.Cell>
        <Table.Cell>{this.fixNumber(cmp) || valueIfNull} %</Table.Cell>
      </React.Fragment>
    );
  }

  renderTotals() {
    const styles = 'lightgray-bg t-bold full-border static-column';
    const totals = this.getTotals();
    return (
      <Table.Row textAlign='center'>
        <Table.HeaderCell className={styles}>TOTAL</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalForeCast || valueIfNull}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalForecastNormal}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalForecastExonerated}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalSales || valueIfNull}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalSalesNormal}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalSalesExonerated}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalPrioritized}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalProyected || valueIfNull}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{Number.isFinite(totals.totalCMP) ?
          this.fixNumber(totals.totalCMP) : 0} %</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailabilityR1}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailabilityR2}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailabilityR3}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailabilityR4}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailabilityR5}</Table.HeaderCell>
        <Table.HeaderCell className={styles}>{totals.totalAvailability || valueIfNull}</Table.HeaderCell>
      </Table.Row>
    );
  }

  render() {
    const {loading} = this.props;
    return (
      <Card raised fluid>
        <div className={`table-sticky-header-and-first-column ${loading ? 'searching' : ''}`}>
          <Table className='gray-table'>
            <Table.Header>
              {this.renderFirstHeaderRow()}
              {this.renderSecondHeaderRow()}
              {this.renderThirdHeaderRow()}
            </Table.Header>
            <Table.Body>
              {this.renderLoaderOrData()}
            </Table.Body>
            <Table.Footer>
              {this.renderTotals()}
            </Table.Footer>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.dailyVehiclesSalesAndStockSummary.loading,
    'wholeSalesAndStockList': state.dailyVehiclesSalesAndStockWholesale.wholeSalesAndStockList,
    'salesAndStockList': state.dailyVehiclesSalesAndStockSummary.salesAndStockList,
    'saleForecast': state.saleForecast.listByDealersAndModels,
  };
};

export default connect(mapStateToProps, {
})(DataTable);
